import { useMutation } from "@tanstack/react-query";
import { deletePlaceholderProfiles } from "PFCore/services/profile";
import { Id } from "PFCore/types";

export const useProfilesPlaceholdersDelete = () =>
  useMutation({
    mutationFn: (profileIds: Id[]) => deletePlaceholderProfiles(profileIds)
  });
